import axios from "axios";
import { getApiBaseUrl } from "../config/api";

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    config.baseURL = getApiBaseUrl();
    return config;
  },
  (error) => Promise.reject(error),
);

// CATEGORY API
export const fetchCategories = ({ lat, lng }) => {
  return api.get("/categories/all/web", {
    params: {
      lat,
      lng,
    },
  });
};

// SERVICES API
export const fetchServicesByCategory = ({
  categoryId,
  page = 1,
  pageSize = 10,
  lat,
  lng,
}) => {
  // Build params object, only include lat/lng if they are defined
  const params = {
    page,
    pageSize,
  };

  // Only add lat/lng if they have values
  if (lat !== undefined && lat !== null) {
    params.lat = lat;
  }
  if (lng !== undefined && lng !== null) {
    params.lng = lng;
  }

  return api.get(`/services/website/by_category/${categoryId}`, {
    params,
  });
};

export default api;
